import React, { useRef, useState } from 'react';
import { Mic, Square, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { api } from '../lib/api';
import { toast } from 'sonner';

export const MicButton = ({ onTranscript, language, disabled, title }) => {
  const [state, setState] = useState('idle');
  const recRef = useRef(null);
  const chunks = useRef([]);

  const start = async () => {
    if (!navigator.mediaDevices?.getUserMedia) { toast.error('Micro non disponible'); return; }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mime = MediaRecorder.isTypeSupported('audio/webm;codecs=opus') ? 'audio/webm;codecs=opus' : 'audio/webm';
      const rec = new MediaRecorder(stream, { mimeType: mime });
      chunks.current = [];
      rec.ondataavailable = (e) => { if (e.data.size) chunks.current.push(e.data); };
      rec.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        const blob = new Blob(chunks.current, { type: 'audio/webm' });
        if (blob.size < 1000) { setState('idle'); return; }
        setState('transcribing');
        try {
          const { text } = await api.transcribe(blob, language);
          if (text) onTranscript(text); else toast.error('Aucune parole détectée');
        } catch (e) { toast.error(e.message); }
        setState('idle');
      };
      rec.start();
      recRef.current = rec;
      setState('recording');
    } catch { toast.error('Accès au micro refusé'); }
  };

  const stop = () => { recRef.current?.stop(); };

  return (
    <Button onClick={state === 'recording' ? stop : start} disabled={disabled || state === 'transcribing'} size="icon" variant="ghost" data-testid="mic-btn" data-state={state} title={title}
      className={`rounded-xl h-10 w-10 shrink-0 ${state === 'recording' ? 'bg-destructive/10 text-destructive hover:bg-destructive/15 hover:text-destructive animate-pulse' : 'text-muted-foreground'}`}>
      {state === 'transcribing' ? <Loader2 className="h-4 w-4 animate-spin" /> : state === 'recording' ? <Square className="h-4 w-4" /> : <Mic className="h-4 w-4" />}
    </Button>
  );
};
